export enum MediaTypeEnum {
  IMAGE = 1,
  FILE = 2,
  VIDEO = 3,
  LINK = 4
}
